<hawk-record-navigation [breadcrumbLinkList]="[]" [root]="'project'" [leafDescription]="'Projekte'" class="app-page">
  <div slot="toolbar" class="flex flex-row gap-2">
    <div style="flex: 1"></div>
    <a class="bm-btn bm-btn-ghost" href="/a/projekt/neu">
      <i class="fa fa-plus"></i>
      Projekt erstellen
    </a>
    <label class="bm-fieldset-label text-nowrap">
      <input
        class="bm-checkbox"
        type="checkbox"
        [(ngModel)]="onlyActiveProjects"
        (change)="updateShownProjects()"
        color="primary"
      />
      Nur aktive Projekte
    </label>
    <input type="text" class="bm-input" placeholder="Schnellfilter..." (input)="quickSearchChanged($event)" />
  </div>
  <div class="page-content page-frame overflow-y-auto">
    <ag-grid-angular
      class="ag-theme-quartz h-full"
      [loadThemeGoogleFonts]="true"
      [rowData]="shownProjects"
      [theme]="hawkTheme"
      [defaultColDef]="defaultColDef"
      [columnDefs]="colDefs"
      [rowClassRules]="rowClassRules"
      [pagination]="true"
      [rowSelection]="rowSelection"
      [autoSizeStrategy]="autoSizeStrategy"
      [paginationPageSize]="100"
      [localeText]="locale"
      [sideBar]="sideBarOptions"
      [paginationPageSizeSelector]="[25, 100, 250, 1000]"
      (gridReady)="onGridReady($event)"
    />
  </div>
</hawk-record-navigation>
